import script from "./pwd_reissue_request.vue?vue&type=script&setup=true&lang=ts"
export * from "./pwd_reissue_request.vue?vue&type=script&setup=true&lang=ts"

import "./pwd_reissue_request.vue?vue&type=style&index=0&id=3bb37bd6&lang=scss&scoped=true"

import exportComponent from "/var/www/ShareMentors/ShareMentors/backend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bb37bd6"]])

export default __exports__